import BrandsPage from 'src/dispensary/brands';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(BrandsPage, MainDispensaryLayout);
